function NotFound(){
    return (
        <h2>Not found</h2>
    )    
}

export default NotFound;
